import { useEffect, useState } from "react";
import { MessageCircle, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const ChatFaqCarousel = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/chat/faq").then((r) => setItems(r.data?.items || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  const ask = (question) => {
    window.dispatchEvent(new CustomEvent("prodrushi:open-chat", { detail: { question } }));
  };

  return (
    <section
      className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8"
      data-testid="home-faq-carousel"
    >
      <Reveal>
        <div className="flex items-center gap-3">
          <Sparkles size={16} className="text-emerald-300" />
          <p className="font-mono text-xs uppercase tracking-widest text-emerald-300">What artists ask most</p>
        </div>
        <h2 className="font-heading mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl">
          Smart FAQ
        </h2>
        <p className="mt-2 max-w-lg text-sm text-zinc-400">
          Tap one — the assistant answers in-line with pricing, pages and tappable beats.
        </p>
      </Reveal>

      <div className="mt-8 flex gap-3 overflow-x-auto pb-2" data-testid="home-faq-scroll">
        {items.map((it, i) => (
          <button
            key={it.question}
            type="button"
            onClick={() => ask(it.question)}
            data-testid={`home-faq-item-${i}`}
            className="group flex w-72 shrink-0 flex-col gap-3 rounded-2xl border border-white/10 bg-[#141419] p-5 text-left transition-colors hover:border-emerald-300/40"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-emerald-300/30 bg-emerald-300/5 text-emerald-200">
              <MessageCircle size={15} />
            </span>
            <p className="text-sm font-medium text-zinc-200 group-hover:text-white">{it.question}</p>
            <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-600">
              Asked {it.count} times · tap to answer
            </p>
          </button>
        ))}
      </div>
    </section>
  );
};
